import React from 'react';

const MonthlyFeatureList = () => (
  <ul>
    <li>🌻 14-Day Free Trial – No charge until your trial ends</li>
    <li>💬 Unlimited Conversations – No caps, no tokens, just talk</li>
    <li>🧠 Memory & Personalization – dAIsy remembers you by name, emotion, and topic</li>
    <li>📅 Cancel Anytime – Full control over your subscription</li>
    <li>🛡️ Private & Secure – Your data is never sold or shared</li>
  </ul>
);

export default MonthlyFeatureList;
